import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class PreloaderService {

  /**
   * @description The selector for the preloader component.
   * @memberof PreloaderService
   * @name PreloaderService#selector
   * @private
   * @property
   * @readonly
   * @type {string}
   */
  private readonly selector: string = 'app-preloader';

  /**
   * @constructor
   * @description Creates an instance of PreloaderService.
   * @memberof PreloaderService
   * @name PreloaderService#constructor
   * @param {Document} document The document object.
   * @public
   */
  public constructor(
    /**
     * @description The document object.
     * @memberof PreloaderService
     * @name PreloaderService#document
     * @private
     * @property
     * @readonly
     * @type {Document}
     */
    @Inject(DOCUMENT) private readonly document: Document) { }

  /**
   * @description Loads the preloader element from the DOM.
   * @memberof PreloaderService
   * @method
   * @name PreloaderService#load
   * @private
   * @returns {HTMLElement | null}
   */
  private getElement(): HTMLElement | null {
    return this.document.querySelector(this.selector);
  }

  /**
   * @description Hides the preloader element.
   * @memberof PreloaderService
   * @method
   * @name PreloaderService#hide
   * @public
   * @returns {void}
   */
  public hide(): void {

    // Localize the element from the DOM.
    const element: HTMLElement | null = this.getElement();

    // Ensure we have an element, then hide it.
    if (element) element.style.display = 'none';
  }
}
